<template>
  <v-container fluid>
    <ShoretelFilter
      :title="title"
      :startDate="startDate"
      :endDate="endDate"
      @accept-date="updateFilter"
    />

    <div class="loading" v-if="loading">
      <v-progress-linear :indeterminate="true"></v-progress-linear>
    </div>

    <ShoretelLogs v-if="!loading" :feeds="feeds" :headers="headers" />
  </v-container>
</template>

<script>
import { Auth } from "aws-amplify";
import AWS from "aws-sdk";
import ShoretelLogs from "./ShoretelLogs.vue";
import ShoretelFilter from "./ShoretelFilter.vue";

export default {
  props: ["title"],

  components: {
    ShoretelLogs,
    ShoretelFilter
  },

  data: () => ({
    loading: true,
    startDate: new Date(new Date().getTime() - 24 * 60 * 60 * 1000)
      .toISOString()
      .substr(0, 10),
    endDate: new Date().toISOString().substr(0, 10),
    headers: [
      {
        text: "Timestamp",
        value: "date",
        width: 200,
        sortable: false
      },
      {
        text: "Location",
        value: "location",
        width: 480,
        sortable: false
      },
      {
        text: "Code",
        value: "code",
        width: 100,
        sortable: false
      },
      {
        text: "Message",
        value: "message",
        sortable: false
      }
    ],
    feeds: []
  }),

  created() {
    this.fetchData();
  },

  methods: {
    updateFilter(val) {
      this.$set(this, "startDate", val.startDate);
      this.$set(this, "endDate", val.endDate);

      this.fetchData();
    },

    async fetchData() {
      this.loading = true;

      const creds = await Auth.currentCredentials();

      const dynamodb = new AWS.DynamoDB.DocumentClient({
        credentials: creds,
        region: "us-west-2"
      });

      let filter = {
        TableName: "shoretel-alerts-v3",
        IndexName: "shoretel-alerts-by-category-v3",
        AttributesToGet: [
          "AlertDate",
          "AlertTime",
          "Computer",
          "NotificationTime",
          "Description",
          "EventID",
          "Type"
        ],
        KeyConditions: {
          Category: {
            ComparisonOperator: "EQ",
            AttributeValueList: ["(2) TMS"]
          },
          AlertDate: {
            ComparisonOperator: "BETWEEN",
            AttributeValueList: [this.startDate, this.endDate]
          }
        }
      };

      let results = await dynamodb.query(filter).promise();
      this.feeds = this.mapData(results.Items);

      this.loading = false;
    },

    mapData(data) {
      // for each entry in the data array, we need to break it up into multiple keys where each key has it own set of logs
      let m = new Map();

      const date_opts = {
        month: "2-digit",
        day: "2-digit",
        year: "numeric"
      };

      const time_opts = {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
      };

      data.forEach(x => {
        if (!m.has(x.Computer)) {
          m.set(x.Computer, []);
        }

        let i = m.get(x.Computer);
        let raw_date = x.AlertDate + "T" + x.AlertTime + "Z";

        let matches = x.Description.match(/^(.*) "(.*)" \((.*)\)./);

        i.push({
          raw_date: raw_date,
          date:
            new Date(raw_date).toLocaleDateString("default", date_opts) +
            " " +
            new Date(raw_date).toLocaleTimeString("default", time_opts),
          location: `${matches[2]} (${matches[3]})`,
          notification_time: x.NotificationTime,
          code: x.EventID,
          message: matches[1],
          isLatest: false,
          isSuccess: false
        });
      });

      m.forEach(v => {
        v.sort((a, b) => {
          return a.raw_date > b.raw_date ? -1 : a.raw_date < b.raw_date ? 1 : 0;
        });

        let locations = new Set();
        // decorate the log entries. entries listed from latest to earliest
        v.forEach(i => {
          if (!locations.has(i.location)) {
            locations.add(i.location);
            i.isLatest = true;
            i.isSuccess = i.code === "234";
          }
        });
      });

      return Array.from(m, ([k, v]) => {
        return { name: k, logs: v };
      }).sort((a, b) => {
        return a.name > b.name ? 1 : a.name < b.name ? -1 : 0;
      });
    }
  }
};
</script>
